import React from "react";
import { useTranslation } from "react-i18next";
import HardwareFeatures from "../HardwareFeatures";
import { WatchHardwareFeatures as watchFeaturesData, watchColorTheme } from "./WatchData";

const WatchHardwareFeatures: React.FC = () => {
    const { t } = useTranslation("hardwareFeatures");

    return (
        <HardwareFeatures
            features={watchFeaturesData}
            colorTheme={watchColorTheme}
            regularText={t("watch.regularText")}
            highlightedText={t("watch.highlightedText")}
            descriptionText={t("watch.descriptionText")}
        />
    );
};

export default WatchHardwareFeatures;